<div class="agpr-formField agpr-socialLinksField agpr-contextMenu-parent">
    <ul>
        <li
            *ngFor="let link of value; index as i"
            class="agpr-socialLinksField-linkCard"
        >
            <div role="group" [attr.aria-label]="'PageBuilder.formField.link.ariaLabel' | localize: {type: wireLinkTypesToLabelStrings[link.linkType]}">
                <!-- Context Menu -->
                <div
                    class="agpr-socialLinksField-linkCard-hoverBorder"
                ></div>
                <ul
                    role="group"
                    [attr.aria-label]="'Amplify.fields.links.settings.linksLabel' | localize"
                    [attr.aria-describedby]="id + '_urlError'"
                >
                    <ul role="menu" class="agpr-contextMenu top left">
                        <li role="menuitem">
                            <agpr-button
                                [id]="id + '_moveUp_' + i"
                                icon="fa-regular fa-arrow-up"
                                tooltip="PageBuilder.briefings.blockIcon.moveUp"
                                tooltipPosition="top"
                                [disabled]="i === 0"
                                (click)="onLinkAction('moveUp', i)"
                                [style]="buttonTypes.contextMenu"
                            ></agpr-button>
                        </li>
                        <li role="menuitem">
                            <agpr-button
                                [id]="id + '_moveDown_' + i"
                                icon="fa-regular fa-arrow-down"
                                tooltip="PageBuilder.briefings.blockIcon.moveDown"
                                tooltipPosition="top"
                                [disabled]="i >= value.length - 1"
                                (click)="onLinkAction('moveDown', i)"
                                [style]="buttonTypes.contextMenu"
                            ></agpr-button>
                        </li>
                    </ul>
                    <ul role="menu"  class="agpr-contextMenu top right">
                        <li role="menuitem">
                            <agpr-button
                                [id]="id + '_delete_' + i"
                                class="agpr-socialLinksField-contextButton"
                                icon="fa-regular fa-duotone fa-trash-can"
                                tooltip="PageBuilder.briefings.blockIcon.delete"
                                tooltipPosition="top"
                                (click)="onLinkAction('delete', i)"
                                [style]="buttonTypes.contextMenu"
                            ></agpr-button>
                        </li>
                    </ul>
                </ul>

                <agpr-dropdown
                    label="PageBuilder.formField.link.linkType"
                    [id]="id + '_LINK_TYPE_' + i"
                    [(ngModel)]="link.linkType"
                    (ngModelChange)="valueChange(link)"
                    [options]="linkTypesOptions"
                    [bindToValue]="true"
                ></agpr-dropdown>
                <agpr-text-input
                    class="agpr-socialLinksField-linkCard-input"
                    [id]="id + '_URL_' + i"
                    label="PageBuilder.formField.link.url"
                    [(ngModel)]="link.url"
                    (ngModelChange)="valueChange(link)"
                    [required]="true"
                    [placeholder]="'PageBuilder.formField.link.urlPlaceholder' | localize"
                    [ariaInvalid]="link.error"
                    [ariaDescribedBy]="id + '_urlError'"
                ></agpr-text-input>
                <agpr-form-message *ngIf="link.error" [id]="id + '_urlError'">
                    {{ 'PageBuilder.formField.link.invalidUrl' | localize }}
                </agpr-form-message>
                <agpr-text-input
                    class="agpr-socialLinksField-linkCard-input"
                    [id]="id + '_LINK_TEXT_' + i"
                    label="PageBuilder.formField.link.text"
                    [(ngModel)]="link.text"
                    (ngModelChange)="valueChange(link)"
                    [placeholder]="'PageBuilder.formField.link.textPlaceholder' | localize"
                ></agpr-text-input>
            </div>
        </li>
    </ul>
    <div class="agpr-socialLinksField-add">
        <agpr-button
            class="agpr-socialLinksField-add-button"
            [style]="buttonTypes.tertiary"
            [label]="'PageBuilder.formField.button.addLinkText'"
            [tooltip]="'PageBuilder.formField.button.addLinkText'"
            [disabled]="value?.length >= 10"
            (click)="addLink()"
        ></agpr-button>
    </div>
</div>
